import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-345">
      <div className="max-w-3xl mx-auto text-center" data-id="element-346">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-347">
          Si sos docente de Lengua y Literatura en secundaria,
          <br data-id="element-348" />
          <span className="text-[#00E68A]" data-id="element-349">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-350">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-351">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-352">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-353">
              Domingos buscando material improvisado, sin estructura, sin
              solucionario — y el lunes llegás con algo que "más o menos sirve"
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-354">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-355">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-356">
              Planificaciones a las corridas, evaluaciones sin rúbricas y
              contenidos difíciles sin secuencia clara para el grupo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-357">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-358">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-359">
              Niveles muy distintos en el mismo curso, material online
              desactualizado y el mismo ciclo agotador cada semana
            </p>
          </div>
        </div>

        <p className="text-[#00E68A] text-2xl sm:text-3xl font-black mb-8" data-id="element-360">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Gold divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00E68A] to-transparent w-full" data-id="element-361" />
      </div>
    </section>;
}